import React, { useMemo } from 'react';
import AppPageHeader from '../shell/AppPageHeader';
import ManagedUserDirectoryPanel from '../shared/ManagedUserDirectoryPanel';
import { useFirmMainHeaderSlot } from './FirmMainHeaderContext';
import { createFirmWorkspaceUsersAdapter } from '../../services/managedDirectoryUsersApi';
import { useAuth } from '../../contexts/AuthContext';
import { canManageUsers } from '../../utils/canManageUsers';

export default function FirmUsers() {
  const { user } = useAuth();
  const adapter = useMemo(() => createFirmWorkspaceUsersAdapter(), []);
  const showManageUsers = canManageUsers(user?.jwtRole);
  const firmHeader = useMemo(() => <AppPageHeader variant="firmShell" title="Users" />, []);
  useFirmMainHeaderSlot(firmHeader);

  return (
    <ManagedUserDirectoryPanel
      preset="firmWorkspace"
      adapter={adapter}
      canManage={showManageUsers}
      idPrefix="firm-workspace"
    />
  );
}
